import { render, staticRenderFns } from "./Tdmvilavelha.vue?vue&type=template&id=6600be16&scoped=true"
import script from "./Tdmvilavelha.vue?vue&type=script&lang=js"
export * from "./Tdmvilavelha.vue?vue&type=script&lang=js"
import style0 from "./Tdmvilavelha.vue?vue&type=style&index=0&id=6600be16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600be16",
  null
  
)

export default component.exports